import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
  private urlApi = environment.rootUrlApi + 'checkout';

  constructor(private http: HttpClient) { }

  public listaCheckOut(dados: any): Observable<any> {
    return this.http.post<any>(this.urlApi + '/listaCheckOut', dados);
  }
  public finalizaPedido(dados: any): Observable<any> {
    return this.http.post<any>(this.urlApi + '/finalizaPedido', dados);
  }
  public listaParcelas(id: number, guid: string): Observable<any> {
    return this.http.get<any>(this.urlApi + '/getParcelasEscola/' + id + '/' + guid);
  }
}
